import entertainmentIndex from '@/views/entertainment/entertainmentIndex.vue'

export default {
  path: '/entertainment',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'entertainmentIndex',
      name: 'entertainmentIndex',
      component: entertainmentIndex
    },


  ]
}
